<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Assignment' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div #modalBody class="modal-body">

    <app-loader *ngIf="isLoading"></app-loader>

    <div class="entity" [ngClass]="{'d-none' : isLoading}">

      <ul class="nav nav-pills nav-wizard mb-4">
        <li class="nav-item ml-0 mr-auto">
          <button class="btn btn-outline-secondary" [disabled]="stepWizard.currentStep > 1 ? false : true" (click)="previousStep()">
            <i class="fa fa-arrow-left"></i> {{'Previous' | translate}}
          </button>
        </li>
        <li class="nav-item ml-auto mr-auto" [ngClass]="{'processed' : step.step < stepWizard.currentStep}" *ngFor="let step of stepWizard.steps">
          <span class="nav-link d-flex flex-row justify-content-between" [ngClass]="{'active': step.step == stepWizard.currentStep}">
            <span class="step-title">
              {{step.step}}. {{step.title | translate}}
            </span>
            <i class="fa fa-check icon icon-valid icon-color icon-circle icon-sm"></i>
          </span>
        </li>
        <li class="nav-item ml-auto">
          <button class="btn btn-outline-primary" [disabled]=" stepWizard.currentStep != stepWizard.steps.length ? false : true" (click)="nextStep()">
            {{'Next' | translate}} <i class="fa fa-arrow-right"></i>
          </button>
        </li>
      </ul>

      <div class="tab-content">

        <div *ngFor="let step of stepWizard.steps;let stepKey = index;" [attr.id]="'#tab-step' + step.step" [ngClass]="{'active': step.step == stepWizard.currentStep}" class="tab-pane">

          <div id="step-1" [ngClass]="{'d-none' : stepWizard.currentStep != 1}" class="step-1">

            <h3 class="tab-title">{{'General' | translate}}</h3>

            <div class="row">

              <div class="col-12">

                <div class="form-group row" *ngIf="trademarkResults.length > 0">
                  <label class="col-form-label col-12 col-sm-4">{{'Trademark' | translate}}</label>
                  <div class="col-12 col-sm-8">
                    <select class="form-control" [(ngModel)]="entity.trademarkId">
                      <option value=""></option>
                      <option [value]="trademark.id" *ngFor="let trademark of trademarkResults">{{trademark.name}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-form-label col-12 col-sm-4">{{'Status' | translate}}*</label>
                  <div class="col-12 col-sm-8">
                    <select class="form-control" [(ngModel)]="entity.status">
                      <option [value]="status.value" *ngFor="let status of jobService.getStatuses()">{{status.label | translate}}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-form-label col-12 col-sm-4">{{'Title' | translate}}*</label>
                  <div class="col-12 col-sm-8">
                    <input type="text" class="form-control" [(ngModel)]="entity.title" />
                    <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'title')">
                      <p>{{'Please fill in a title' | translate}}</p>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-form-label col-12 col-sm-4">{{'City' | translate}}</label>
                  <div class="col-12 col-sm-8">
                    <input type="text" class="form-control" [(ngModel)]="entity.location" />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-form-label col-12 col-sm-4">{{'Description' | translate}}*</label>
                  <div class="col-12 col-sm-8">
                    <ckeditor [editor]="Editor" [className]="'job_description editor_lg'" [config]="editorConfig" [(ngModel)]="entity.description"></ckeditor>
                    <div class="alert alert-danger validation-error" *ngIf="showValidationError(1, 'entity', 'description')">
                      <p>{{'Please fill in a description' | translate}}</p>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-form-label col-12 col-sm-4">{{'Assignment requirements' | translate}}</label>
                  <div class="col-12 col-sm-8">
                    <ckeditor [editor]="Editor" [className]="'job_requirements editor_lg'" [config]="editorConfig" [(ngModel)]="entity.requirements"></ckeditor>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-form-label col-12 col-sm-4">{{'Project terms' | translate}}</label>
                  <div class="col-12 col-sm-8">
                    <ckeditor [editor]="Editor" [className]="'employment_conditions editor_lg'" [config]="editorConfig" [(ngModel)]="entity.termsOfEmployment"></ckeditor>
                  </div>
                </div>

                <div class="form-group row d-none">
                  <label class="col-form-label col-12 col-sm-4">{{'Additional information' | translate}}</label>
                  <div class="col-12 col-sm-8">
                    <ckeditor [editor]="Editor" [className]="'additional_information editor_lg'" [config]="editorConfig" [(ngModel)]="entity.additionalInfo"></ckeditor>
                  </div>
                </div>

                <div class="form-group row d-none">
                  <label class="col-form-label col-12 col-sm-4">{{'Direct apply link' | translate}}</label>
                  <div class="col-12 col-sm-8">
                    <input type="text" class="form-control" [(ngModel)]="entity.externalReferenceUri" />
                  </div>
                </div>

              </div>

            </div>

          </div>

          <div id="step-2" [ngClass]="{'d-none' : stepWizard.currentStep != 2}" class="step-2">

            <h3 class="tab-title">{{'Match' | translate}}</h3>

            <!-- competencies wrapper -->
            <div class="matchtest-competences-wrapper">

              <!-- competencies -->
              <div class="matchtest-competences-groups-wrapper">

                <!-- company culture -->
                <div class="matchtest-competence-group-wrapper">

                  <h3>{{'Company culture' | translate}}</h3>

                  <!-- factor company culture -->
                  <div class="form-group row">
                    <label class="col-form-label col-sm-12">{{'Weighting percentage' | translate}}</label>
                    <div class="col-12 col-sm-6">
                      <div class="input-group">
                        <input class="form-control" type="number" (change)="onFactorChange('companyCultureFactor')" (keyup)="onFactorChange('companyCultureFactor')" [(ngModel)]="matchcriterion.companyCultureFactor" />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            %
                          </span>
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- selectable competencies company culture -->
                  <div class="row">

                    <!-- selectable options go here -->
                    <div class="col-12 col-sm-6">

                      <p>{{'Select maximum 5 competences' | translate}}</p>

                      <div *ngFor="let competency of matchCompetencyCompanyCulture; let cKey = index;">

                        <!-- checkable option -->
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" [checked]="hasMatchtestCompetenceValue(competency['id'], 'companyCultureCompetencies')">
                          <label class="custom-control-label" (click)="toggleMatchtestCompetence(competency['id'], 'companyCultureCompetencies')">
                            {{competency.name | translate}}
                          </label>
                        </div>

                      </div>
                    </div>

                    <!-- selected values go here -->
                    <div class="col-12 col-sm-6">

                      <p>
                        {{'Sort the selected competences based on priority' | translate}}
                      </p>

                      <ul class="list-group">
                        <li *ngFor="let competencyMatchcriterion of matchcriterion.companyCultureCompetencies; let key = index;" class="list-group-item d-flex flex-row justify-content-between">
                          <span class="text">
                            {{key + 1}}.
                            {{competencyMatchcriterion.name | translate}}
                          </span>
                          <div class="btn-group">
                            <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyUp(key, 'companyCultureCompetencies')">
                              <fa-icon [icon]="faChevronUp"></fa-icon>
                            </button>
                            <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyDown(key, 'companyCultureCompetencies')">
                              <fa-icon [icon]="faChevronDown"></fa-icon>
                            </button>
                          </div>
                        </li>
                      </ul>

                    </div>

                  </div>

                </div>

                <!-- personality culture -->
                <div class="matchtest-competence-group-wrapper mt-3">

                  <h3>{{'Personality traits' | translate}}</h3>

                  <!-- factor personality -->
                  <div class="form-group row">
                    <label class="col-form-label col-sm-12">{{'Weighting percentage' | translate}}</label>
                    <div class="col-12 col-sm-6">
                      <div class="input-group">
                        <input class="form-control" type="number" (change)="onFactorChange('personalityFactor')" (keyup)="onFactorChange('personalityFactor')" [(ngModel)]="matchcriterion.personalityFactor" />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            %
                          </span>
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- selectable competencies personality -->
                  <div class="row">

                    <!-- selectable options go here -->
                    <div class="col-12 col-sm-6">

                      <p>{{'Select maximum 2 competences' | translate}}</p>

                      <div *ngFor="let competency of matchCompetencyPersonality; let cKey = index;">

                        <!-- checkable option -->
                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" [checked]="hasMatchtestCompetenceValue(competency['id'], 'personalityCompetencies')">
                          <label class="custom-control-label" (click)="toggleMatchtestCompetence(competency['id'], 'personalityCompetencies')">
                            {{competency.name | translate}}
                          </label>
                        </div>

                      </div>
                    </div>

                    <!-- selected values go here -->
                    <div class="col-12 col-sm-6">

                      <p>
                        {{'Sort the selected competences based on priority' | translate}}
                      </p>

                      <ul class="list-group">
                        <li *ngFor="let competencyMatchcriterion of matchcriterion.personalityCompetencies; let key = index;" class="list-group-item d-flex flex-row justify-content-between">
                          <span class="text">
                            {{key + 1}}.
                            {{competencyMatchcriterion.name | translate}}
                          </span>
                          <div class="btn-group">
                            <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyUp(key, 'personalityCompetencies')">
                              <fa-icon [icon]="faChevronUp"></fa-icon>
                            </button>
                            <button class="btn btn-sm btn-outline-secondary" (click)="moveMatchcriterionCompetencyDown(key, 'personalityCompetencies')">
                              <fa-icon [icon]="faChevronDown"></fa-icon>
                            </button>
                          </div>
                        </li>
                      </ul>

                    </div>

                  </div>

                </div>

              </div>

            </div>

            <div class="areaofinterests">

              <h3>{{'Field of interest' | translate}}</h3>

              <div class="form-group row">
                <label class="col-form-label col-12">{{'Weighting percentage' | translate}}</label>
                <div class="col-12 col-sm-6">
                  <div class="input-group">
                    <input class="form-control" type="number" (change)="onFactorChange('areaOfInterestFactor')" (keyup)="onFactorChange('areaOfInterestFactor')" [(ngModel)]="matchcriterion.areaOfInterestFactor" />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </div>

              <app-selector-areaofinterests [maxAmount]="15" *ngIf="areaOfInterests" [(ngModel)]="entity.areaOfInterests" [data]="areaOfInterests"></app-selector-areaofinterests>

            </div>

          </div>


          <div id="step-3" [ngClass]="{'d-none' : stepWizard.currentStep != 3}" class="step-3">

            <h3 class="tab-title">{{'Requirements' | translate}}</h3>

            <!-- immediately available -->
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.immediatelyAvailable" id="immediatelyAvailable">
                <label class="custom-control-label" for="immediatelyAvailable">{{'Immediately available' | translate}}</label>
              </div>
            </div>

            <!-- start date -->
            <div class="form-group row">
              <label class="col-form-label col-12 col-sm-4">{{'Start date' | translate}}</label>
              <div class="col-12 col-sm-8">
                <input ngbDatepicker class="form-control" [(ngModel)]="entity.startDate" (click)="startdate.toggle()" #startdate="ngbDatepicker" />
              </div>
            </div>

            <!-- deadline -->
            <div class="form-group row">
              <label class="col-form-label col-12 col-sm-4">{{'Deadline' | translate}}</label>
              <div class="col-12 col-sm-8">
                <input ngbDatepicker class="form-control" [(ngModel)]="entity.deadline" (click)="deadline.toggle()" #deadline="ngbDatepicker" />
              </div>
            </div>

            <!-- fulltime / partttime -->
            <div class="form-group row">
              <label class="col-form-label col-12 col-sm-4">{{'Fulltime' | translate}} / {{'Parttime' | translate}}*</label>
              <div class="col-12 col-sm-8">

                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="hours1" [(ngModel)]="entity.hours" class="custom-control-input" [value]="jobpostingHours.Parttime">
                  <label class="custom-control-label" for="hours1">{{'Parttime' | translate}}</label>
                </div>

                <div class="custom-control custom-radio custom-control-inline">
                  <input type="radio" id="hours2" [(ngModel)]="entity.hours" class="custom-control-input" [value]="jobpostingHours.Fulltime">
                  <label class="custom-control-label" for="hours2">{{'Fulltime' | translate}}</label>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(3, 'entity', 'hours')">
                  <p>{{'Please select an option' | translate}}</p>
                </div>

              </div>
            </div>

            <!-- hours per week -->
            <div class="form-group row">
              <label class="col-form-label col-12 col-sm-4">{{'Number of hours per week' | translate}}</label>
              <div class="col-12 col-sm-8">
                <input type="number" class="form-control" [(ngModel)]="entity.hoursPerWeek" />
              </div>
            </div>

            <!-- experience desired -->
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.isExperienceDesired" id="isExperienceDesired">
                <label class="custom-control-label" for="isExperienceDesired">{{'Experience desired' | translate}}</label>
              </div>
            </div>

            <!-- attachment file -->
            <div class="form-group" [ngClass]="{'d-none': entity.documents.length > 0}">
              <div class="custom-file">
                <input type="file" class="custom-file-input" (change)="attachmentFileChangeEvent($event)" id="attachmentFile">
                <label class="custom-file-label" for="attachmentFile" [attr.data-browse]="'Select file' | translate">{{'Attachment' | translate}}</label>
              </div>
            </div>

            <!-- existing attachments -->
            <div class="attachments mb-3" *ngIf="entity.documents.length > 0">
              {{'Attachment' | translate}}
              <div class="row" *ngFor="let document of entity.documents">
                <div class="col-12 col-sm-8">
                  {{document.filename}}
                </div>
                <div class="col-12 col-sm-4">

                  <div class="btn-toolbar justify-content-end">
                    <a class="btn btn-outline-primary mr-3" [href]="document.uri" target="_blank">
                      <fa-icon [icon]="faDownload"></fa-icon>
                      {{'Download' | translate}}
                    </a>
                    <button class="btn btn-danger" (click)="deleteJobPostingDocument(document.id)">
                      {{'Delete' | translate}}
                    </button>
                  </div>

                </div>
              </div>
            </div>

          </div>

          <div id="step-4" [ngClass]="{'d-none' : stepWizard.currentStep != 4}" class="step-4">

            <h3 class="tab-title">{{'Education' | translate}}</h3>

            <div class="row" *ngIf="groupedEducationLevels">

              <span class="col-lg-3 col-sm-12" *ngFor="let region of Object.keys(groupedEducationLevels)">

                <h5>{{region}}</h5>

                <div class="row" *ngIf="groupedEducationLevels[region]">

                  <div class="col-12" *ngFor="let educationLevel of groupedEducationLevels[region]; let eKey = index;">

                    <div class="education-level card mb-3">

                      <div class="card-body">

                        <div class="custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" [checked]="existsEducationLevel(educationLevel.id)" [attr.id]="'education-level-' + (eKey + 1)">
                          <label class="custom-control-label" [attr.for]="'education-level-' + (eKey + 1)" (click)="toggleEducationLevel(educationLevel.id)">
                            {{educationLevel.name}}
                          </label>
                        </div>

                        <!-- profiles -->
                        <div class="education-level-profiles card mt-3" *ngIf="educationLevel['educationProfiles'] && educationLevel['educationProfiles'].length > 0 && existsEducationLevel(educationLevel.id)">
                          <div class="card-header">
                            {{'Profiles' | translate}}
                          </div>
                          <div class="card-body">

                            <div *ngFor="let profile of educationLevel['educationProfiles']; let epKey = index;">

                              <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [checked]="existsEducationLevelProfile(educationLevel.id, profile)" [attr.id]="'education-level-profile-' + (epKey + 1)">
                                <label class="custom-control-label" (click)="toggleEducationLevelProfile(educationLevel.id, profile)" [attr.for]="'education-level-profile-' + (epKey + 1)">
                                  {{profile['name']}}
                                </label>
                              </div>

                            </div>

                          </div>

                        </div>

                        <!-- phases -->
                        <div class="education-level-phases card mt-3" *ngIf="educationLevel.phases && educationLevel.phases.length > 0 && existsEducationLevel(educationLevel.id)">
                          <div class="card-header">
                            {{'Phases' | translate}}
                          </div>
                          <div class="card-body">

                            <div *ngFor="let phase of educationLevel.phases; let ephKey = index;">

                              <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" [checked]="existsEducationLevelPhase(educationLevel.id, phase)" [attr.id]="'education-level-phase-' + (ephKey + 1)">
                                <label class="custom-control-label" (click)="toggleEducationLevelPhase(educationLevel.id, phase)" [attr.for]="'education-level-phase-' + (ephKey + 1)">
                                  {{phase}}
                                </label>
                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>

              </span>



            </div>

          </div>

          <div id="step-5" [ngClass]="{'d-none' : stepWizard.currentStep != 5}" class="step-5">

            <h3 class="tab-title">{{'Contact' | translate}}</h3>

            <!-- address -->
            <div class="row">

              <div class="col-sm-12">
                <div class="alert alert-danger validation-error" *ngIf="showValidationError(5, 'entity', 'street', 'address')">
                  <p>{{'Please fill in your street name' | translate}}</p>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(5, 'entity', 'number', 'address')">
                  <p>{{'Please fill in your street number' | translate}}</p>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(5, 'entity', 'city', 'address')">
                  <p>{{'Please fill in your city' | translate}}</p>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(5, 'entity', 'postalCode', 'address')">
                  <p>{{'Please fill in your postal code' | translate}}</p>
                </div>

                <div class="alert alert-danger validation-error" *ngIf="showValidationError(5, 'entity', 'country', 'address')">
                  <p>{{'Please select your country' | translate}}</p>
                </div>
              </div>

              <div class="col-sm-8">
                <div class="form-group">
                  <label>{{'Street' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.street" />
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label>{{'No.' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.number" />
                </div>
              </div>

              <div class="col-sm-2">
                <div class="form-group">
                  <label>{{'Addition' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.numberSuffix" />
                </div>
              </div>

              <div class="col-sm-8">
                <div class="form-group">
                  <label>{{'City' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.city" />
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label>{{'Postal code' | translate}}</label>
                  <input type="text" class="form-control" [(ngModel)]="entity.address.postalCode" />
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label>{{'Country' | translate}}</label>
                  <select class="form-control" [(ngModel)]="entity.address.country">
                    <option *ngFor="let option of locale.availableCountries()" [value]="option.code">{{option.name}}</option>
                  </select>
                </div>
              </div>

            </div>

            <div class="form-group">
              <label>{{'Select contact person' | translate}}</label>
              <select class="form-control" [(ngModel)]="entity.contactPersonId">
                <option [value]="''">-</option>
                <option *ngFor="let contact of companyAccounts" [value]="contact.id">
                  {{contact.firstName + ' ' + contact.lastName}}
                </option>
              </select>
            </div>


            <div class="btn-toolbar">
              <button class="btn btn-primary ml-auto" (click)="Save()">
                <fa-icon [icon]="faSave"></fa-icon>
                {{'Save' | translate}}
                <fa-icon [icon]="faSpinner" animation="spin" *ngIf="isProcessing"></fa-icon>
              </button>
            </div>

          </div>

        </div>

        <div class="setup-controls btn-toolbar d-flex flex-grow-1 align-items-stretch justify-content-between mb-3">

          <button class="btn btn-outline-secondary" (click)="previousStep()" *ngIf="stepWizard.currentStep > 1">
            <i class="fa fa-arrow-left"></i> {{'Previous' | translate}}
          </button>

          <button class="btn btn-outline-primary ml-auto" *ngIf="stepWizard.currentStep != stepWizard.steps.length" (click)="nextStep()">
            {{'Next' | translate}} <i class="fa fa-arrow-right"></i>
          </button>

        </div>

      </div>

    </div>


  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-end">
      <button type="button" class="btn btn-primary" (click)="activeModal.close(true)">{{'Close' | translate}}</button>
    </div>
  </div>
</div>
